import axios from "axios"
import ROOTURL from "./ROOTURL"
import { BUSINESSID } from "./ROOTURL"

export const GetUserAPI = (userId) => axios.get(`${ROOTURL}/users/${userId}`)

export const createNewUser = (data) => axios.post(`${ROOTURL}/users`, data)

export const getCustomerAddress = (userID) =>
  axios.get(`${ROOTURL}/useraddress/${userID}`)

export const createUserAddress = (data) =>
  axios.post(`${ROOTURL}/useraddress`, data)

export const getUserOrders = (userId) =>
  axios.get(
    `${ROOTURL}/customertransaction?customerID=${userId}&businessID=${BUSINESSID}`
  )

export const sendReceiptMail = (receiptID) =>
  axios.get(`${ROOTURL}/sendreceiptemail/${receiptID}`)

export const sendReceiptSms = (receiptID) =>
  axios.get(`${ROOTURL}/sendreceiptsms/${receiptID}`)
